// Custodians captured for selection but with no integrated paperwork — Ops
// handles it manually (e.g. Goldman Sachs). Matched by exact value, not a
// substring, so a future variant like "goldman_iws" can't silently match.
//
// Two spellings are checked because onboarding_task_datum.custodian is stored
// inconsistently (SV-515): the sidecar writes the serialized `goldman_sachs`,
// while the legacy IAA dialog persists the display name `Goldman Sachs`.
const CAPTURE_ONLY_CUSTODIAN_VALUES: ReadonlySet<string> = new Set(['goldman_sachs', 'Goldman Sachs']);

export function isCaptureOnlyCustodian(custodian: string | null | undefined): boolean {
  return CAPTURE_ONLY_CUSTODIAN_VALUES.has(custodian ?? '');
}
